import { gql } from 'apollo-boost'

export const UPDATE_SALESMATE_COMPANY_TAGS = gql`
  mutation salesmate($eventName: String!, $companyId: String, $tagsToAdd: [String], $tagsToRemove: [String]) {
    salesmate(eventName: $eventName, companyId: $companyId, tagsToAdd: $tagsToAdd, tagsToRemove: $tagsToRemove)
  }
`
